export enum NutrientKey {
    PROTEIN = 'PROTEIN',
    CARBS = 'CARBS',
    FAT = 'FAT',
    SATURATED_FAT = 'SATURATED_FAT',
    SUGAR = 'SUGAR',
    FIBER = 'FIBER',
    SALT = 'SALT',
}

export const ALL_NUTRIENT_KEYS = Object.values(NutrientKey) as NutrientKey[];

export type NutrientValue = {
    key: NutrientKey;
    amount: number;
};

export function isNutrientKey(value: string): value is NutrientKey {
    return (ALL_NUTRIENT_KEYS as string[]).includes(value);
}

export const NUTRIENT_AMOUNT_DECIMALS = 2;

export function roundNutrientAmount(amount: number): number {
    const factor = 10 ** NUTRIENT_AMOUNT_DECIMALS;
    return Math.round(amount * factor) / factor;
}

export function formatNutrientAmount(amount: number): string {
    const rounded = roundNutrientAmount(amount);
    if (!Number.isFinite(rounded)) return '0';
    if (Number.isInteger(rounded)) return String(rounded);
    return rounded.toFixed(NUTRIENT_AMOUNT_DECIMALS).replace(/0+$/, '').replace(/\.$/, '');
}

export function normalizeNutrientValues(values: NutrientValue[] | null | undefined): NutrientValue[] {
    if (!values?.length) return [];
    const byKey = new Map<NutrientKey, number>();
    for (const row of values) {
        if (!isNutrientKey(row.key)) continue;
        const amount = roundNutrientAmount(Number(row.amount));
        if (!Number.isFinite(amount) || amount <= 0) continue;
        byKey.set(row.key, amount);
    }
    return ALL_NUTRIENT_KEYS.filter(key => byKey.has(key)).map(key => ({ key, amount: byKey.get(key)! }));
}
